const countries = {
  slug: 'f/countries',
  getCurrentCountyInfo: () => `${countries.slug}/current`
}

export default countries
